var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWhatsapp01 = function SvgIconWhatsapp01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_whatsapp-01_svg2__a",
    x1: 112.48,
    x2: -4.67,
    y1: 119.52,
    y2: -7.08,
    gradientTransform: "matrix(1 0 0 -1 0 102)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_whatsapp-01_svg2__a",
    id: "icon_whatsapp-01_svg2__b",
    x1: 112.32,
    x2: -4.78,
    y1: 119.64,
    y2: -6.96
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M50.05 0C22.5 0 .05 22.45.05 50s2.6 18.55 7.55 26.45c-1.95 6.9-5.55 20-5.6 20.15-.2.7 0 1.4.5 1.9s1.25.65 1.9.45l19.8-6.1c7.75 4.7 16.65 7.15 25.75 7.15 27.55 0 50-22.45 50-50S77.6 0 50.05 0m0 96.15c-8.7 0-17.15-2.45-24.5-7-.3-.2-.65-.3-1-.3s-.4 0-.55.1L6.7 94.3c1.25-4.65 3.55-12.95 4.9-17.55.15-.55.05-1.1-.25-1.6a45.97 45.97 0 0 1-7.45-25.1c0-25.5 20.7-46.2 46.15-46.2S96.2 24.55 96.2 50 75.5 96.15 50.05 96.15",
    style: {
      fill: "url(#icon_whatsapp-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7 61.8c-3.55-1.95-6.55-3.95-8.8-5.4-1.7-1.1-2.9-1.9-3.8-2.35-2.5-1.25-4.4-.35-5.1.35-.1.1-.15.2-.25.3-2.6 3.9-5.95 7.6-6.95 7.8-1.15-.2-6.5-3.2-11.8-7.65-5.45-4.55-8.85-8.85-9.35-11.8 3.5-3.6 4.75-5.85 4.75-8.4s-6.2-13.7-7.3-14.8-3.65-1.3-7.5-.5c-.35.05-.7.25-1 .5-.45.45-11.4 11.6-6.2 25.15 5.7 14.85 20.35 32.05 39 34.85 2.1.3 4.1.5 5.95.5 11 0 17.45-5.55 19.3-16.5.15-.8-.25-1.6-.95-2zM59 76c-19.75-2.95-32.15-22.5-36-32.45-3.8-9.85 3.2-18.65 4.95-20.6 1.45-.25 2.95-.35 3.55-.25 1.3 1.8 5.85 10.4 6.05 11.95 0 1-.35 2.4-4.25 6.35-.35.35-.55.85-.55 1.35 0 10.05 21.25 24.05 25 24.05s7.55-5.5 9.95-9.1c.15 0 .4.05.7.2.7.35 1.9 1.15 3.4 2.1 2 1.3 4.65 3.05 7.8 4.85-1.45 6.85-5.4 13.8-20.65 11.5z",
    style: {
      fill: "url(#icon_whatsapp-01_svg2__b)"
    }
  }));
};
export default SvgIconWhatsapp01;